addEventListener("DOMContentLoaded", () => {

  //~~~~~~~~~~~ main nav and mega dropdown ~~~~~~~~~~~//
  const body = document.querySelector('body');
  const nav = document.querySelector('.main-navigation');
  const navItems = document.querySelectorAll('.main-navigation > ul > li');
  
  navItems.forEach(function (item) {

    item.addEventListener( 'mouseenter', () => {
      // adds active class to top level item
      item.classList.add('active');
      
      // shows mega dropdown for this item
      if(item.classList.contains('mega-dropdown-item')) {
        let navItemClass = item.classList[0];
        let megaDD = document.querySelector('.main-navigation__mega-dropdown.'+navItemClass);

        megaDD.classList.add('show');

        megaDD.addEventListener( 'mouseleave', () => {
          if( ! item.classList.contains('active') ) {
            megaDD.classList.remove('show');
          }
        });
      }
    });

    item.addEventListener( 'mouseleave', () => {
      
      // removes active class to top level item
      item.classList.remove('active');

      if(item.classList.contains('mega-dropdown-item')) {
        let navItemClass = item.classList[0];
        let megaDD = document.querySelector('.main-navigation__mega-dropdown.'+navItemClass);

        megaDD.addEventListener( 'mouseenter', () => {
          item.classList.add('active');
          megaDD.classList.add('show');
        });

        megaDD.addEventListener( 'mouseleave', () => {
          item.classList.remove('active');
          megaDD.classList.remove('show');
        });

        if( ! item.classList.contains('active') ) {
          megaDD.classList.remove('show');
        }
      }

    });

  });
  //~~~~~~~~~~~ main nav and mega dropdown ~~~~~~~~~~~//

  //~~~~~~~~~~~ mobile nav ~~~~~~~~~~~//
  if( nav ) {
    const menuToggle = document.querySelector('.menu-toggle');
    const mobileDropdownItems = nav.querySelectorAll('.dropdown-item');
    const mobileMegaDropdownItems = nav.querySelectorAll('.mega-dropdown-item');
    menuToggle.addEventListener('click', () => {
      // Set Active Class
      nav.classList.toggle('active');
      menuToggle.classList.toggle('active');
      body.classList.toggle('scroll-lock');
      body.classList.toggle('mobile-nav');

    });

    // mobile dropdowns
    mobileDropdownItems.forEach(function (item) {
      item.addEventListener('click', () => {
        // Set Active Class
        item.classList.toggle('active');
        item.querySelector('.main-navigation__dropdown').classList.toggle('open');
      });
    });

    mobileMegaDropdownItems.forEach(function (item) {
      item.addEventListener('click', () => {
        // Set Active Class
        item.classList.toggle('active');
        item.nextElementSibling.classList.toggle('open');
      });
    });
  }
  
  //~~~~~~~~~~~ mobile nav ~~~~~~~~~~~//

});  

return;